/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnumerationValueListDto } from './EnumerationValueListDto';
import {
    instanceOfEnumerationValueListDto,
    EnumerationValueListDtoFromJSON,
    EnumerationValueListDtoFromJSONTyped,
    EnumerationValueListDtoToJSON,
} from './EnumerationValueListDto';
import type { NumericDataSetFilterDto } from './NumericDataSetFilterDto';
import {
    instanceOfNumericDataSetFilterDto,
    NumericDataSetFilterDtoFromJSON,
    NumericDataSetFilterDtoFromJSONTyped,
    NumericDataSetFilterDtoToJSON,
} from './NumericDataSetFilterDto';
import type { TextValueListDto } from './TextValueListDto';
import {
    instanceOfTextValueListDto,
    TextValueListDtoFromJSON,
    TextValueListDtoFromJSONTyped,
    TextValueListDtoToJSON,
} from './TextValueListDto';

/**
 * @type ISetupParameterFilter
 * 
 * @export
 */
export type ISetupParameterFilter = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared' } & EnumerationValueListDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataSetFilterDto, Ptw.Ptw100.AppZero.Application.Shared' } & NumericDataSetFilterDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.TextValueListDto, Ptw.Ptw100.AppZero.Application.Shared' } & TextValueListDto;


export function ISetupParameterFilterFromJSON(json: any): ISetupParameterFilter {
    return ISetupParameterFilterFromJSONTyped(json, false);
}

export function ISetupParameterFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISetupParameterFilter {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, EnumerationValueListDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataSetFilterDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, NumericDataSetFilterDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataSetFilterDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.TextValueListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TextValueListDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.TextValueListDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of ISetupParameterFilter exists with '$type=${json['$type']}'`);
    }
}

export function ISetupParameterFilterToJSON(value?: ISetupParameterFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationValueListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return EnumerationValueListDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataSetFilterDto, Ptw.Ptw100.AppZero.Application.Shared':
            return NumericDataSetFilterDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.TextValueListDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TextValueListDtoToJSON(value);
        default:
            throw new Error(`No variant of ISetupParameterFilter exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the ISetupParameterFilter interface.
 */
export function instanceOfISetupParameterFilter(value: any): value is ISetupParameterFilter {
    if (instanceOfEnumerationValueListDto(value)) return true;
    if (instanceOfNumericDataSetFilterDto(value)) return true;
    if (instanceOfTextValueListDto(value)) return true;
    return false;
}

